var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-container"},[_c('div',{staticClass:"toast-container"},_vm._l((_vm.$toasts),function(toast,index){return _c('Toast',{key:index,attrs:{"toast":toast}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }